import React from 'react'
import Home from 'pages/Dashboard'
import ProductList from 'pages/Dashboard/ProductsList'
import ProductDetail from 'pages/Dashboard/ProductDetail'
import QuickOrder from 'pages/Dashboard/QuickOrder'
import Cart from 'pages/Dashboard/Cart'
import Checkout from 'pages/Dashboard/Checkout'
import Promotion from 'pages/Dashboard/Promotion'
import PromoCodes from 'pages/Dashboard/PromoCodes'
import WishlistPage from 'pages/Dashboard/User/WishlistPage'
import Productviewed from 'pages/Dashboard/User/Productviewed'
import HistoryPurchased from 'pages/Dashboard/User/HistoryPurchased'
import Import from 'pages/Dashboard/BulkOrder/Import'
import MyOrder from 'pages/Dashboard/User/MyOrder'
import MyOrderDetail from 'pages/Dashboard/User/MyOrderDetail'
import MyAccount from 'pages/Dashboard/User/MyAccount'
import LoyaltyPoints from 'pages/Dashboard/User/LoyaltyPoints'
import MyVoucher from 'pages/Dashboard/User/MyVoucher'
import TongQuan from 'pages/Dashboard/TongQuan'
import HuongDanDatHang from 'pages/Dashboard/HuongDanDatHang'
import DieuKhoanSuDung from 'pages/Dashboard/DieuKhoanSuDung'
import GioiThieu from 'pages/Dashboard/GioiThieu'
import BaoMat from 'pages/Dashboard/BaoMat'
import DoiTra from 'pages/Dashboard/DoiTra'
import BanHang from 'pages/Dashboard/BanHang'
import QuyChe from 'pages/Dashboard/QuyChe'
import VanChuyen from 'pages/Dashboard/VanChuyen'
import HuongDan from 'pages/Dashboard/HuongDan'

export interface RouteConfig {
  path: string
  name: string
  element: React.ReactNode
}

export const routes: RouteConfig[] = [
  { path: '/', name: 'Trang chủ', element: <Home /> },
  { path: '/products', name: 'Danh sách sản phẩm', element: <ProductList /> },
  { path: '/products/:category_slug', name: 'Sản phẩm theo danh mục', element: <ProductList /> },
  { path: '/products/lasted', name: 'Sản phẩm mới nhất', element: <ProductList /> },
  { path: '/product/:slug', name: 'Chi tiết sản phẩm', element: <ProductDetail /> },
  { path: '/quick-order', name: 'Đặt hàng nhanh', element: <QuickOrder /> },
  { path: '/promotion', name: 'Khuyến mãi', element: <Promotion /> },
  { path: '/promo-codes', name: 'Mã khuyến mãi', element: <PromoCodes /> },
  { path: '/cart', name: 'Giỏ hàng', element: <Cart /> },
  { path: '/checkout', name: 'Thanh toán', element: <Checkout /> },
  { path: '/user/wishlist', name: 'Sản phẩm yêu thích', element: <WishlistPage /> },
  { path: '/productviewed', name: 'Sản phẩm đã xem', element: <Productviewed /> },
  { path: '/history-purchased', name: 'Lịch sử mua hàng', element: <HistoryPurchased /> },
  { path: '/bulk-order/import', name: 'Nhập đơn hàng số lượng lớn', element: <Import /> },
  { path: '/my-order', name: 'Đơn hàng của tôi', element: <MyOrder /> },
  { path: '/my-order/:slug', name: 'Chi tiết đơn hàng', element: <MyOrderDetail /> },
  { path: '/my-account', name: 'Tài khoản của tôi', element: <MyAccount /> },
  { path: '/users/loyalty_points', name: 'Điểm tích lũy', element: <LoyaltyPoints /> },
  { path: '/users/my-voucher', name: 'Voucher của tôi', element: <MyVoucher /> },
  { path: '/tong-quan', name: 'Tổng quan', element: <TongQuan /> },
  { path: '/huong-dan-dat-hang', name: 'Hướng dẫn đặt hàng', element: <HuongDanDatHang /> },
  { path: '/dieu-khoan-su-dung', name: 'Điều khoản sử dụng', element: <DieuKhoanSuDung /> },
  { path: '/gioi-thieu', name: 'Giới thiệu', element: <GioiThieu /> },
  { path: '/chinh-sach-bao-mat', name: 'Chính sách bảo mật', element: <BaoMat /> },
  { path: '/chinh-sach-doi-tra', name: 'Chính sách đổi trả', element: <DoiTra /> },
  { path: '/chinh-sach-ban-hang', name: 'Chính sách bán hàng', element: <BanHang /> },
  { path: '/quy-che-hoat-dong', name: 'Quy chế hoạt động', element: <QuyChe /> },
  { path: '/chinh-sach-van-chuyen', name: 'Chính sách vận chuyển', element: <VanChuyen /> },
  { path: '/huong-dan', name: 'Hướng dẫn', element: <HuongDan /> },
]
